import { render, staticRenderFns } from "./ArticleTitleTour.vue?vue&type=template&id=674fea79&scoped=true&"
import script from "./ArticleTitleTour.vue?vue&type=script&lang=js&"
export * from "./ArticleTitleTour.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTitleTour.vue?vue&type=style&index=0&id=674fea79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674fea79",
  null
  
)

export default component.exports